module.exports = __webpack_public_path__ + "img/apple_logo.9e548d38.svg";